import { useNavigate, useParams } from 'react-router-dom';

import { useApi } from '../../../context/ApiProvider';
import useAuth from '../../../hooks/useAuth';
import { useAdminDashboardContext } from '../../../context/AdminDashboardDataContext';

export const useDashboard = () => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const { dashboardData, loading } = useAdminDashboardContext();
  const { id: tenantId } = useParams<{ id: string }>();
  const { apiReportController } = useApi();
  const today = new Date();
  const isSuperAdmin = auth.loggedUserDto.superAdmin;

  const onDownloadReport = async (outputType: 'PDF' | 'XLSX') => {
    try {
      const response = await apiReportController('month-stake-statistics').get('', {
        params: {
          tenantId,
          month: today.getMonth() + 1,
          year: today.getFullYear(),
          outputType
        },
        responseType: 'blob'
      });

      const fileName = response.headers['content-disposition']?.split('filename=')[1];

      const blob = new Blob([response.data], {
        type: outputType === 'PDF' ? 'application/pdf' : 'application/vnd.ms-excel'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${fileName}`;
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Failed to download report:', error);
    }
  };

  const onSeeMoreClick = () =>
    navigate(
      `/${isSuperAdmin ? 'superAdmin/branches' : 'tenantAdmin'}/id/${tenantId}/kitchen/summary`
    );

  return { loading, dashboardData, tenantId, onDownloadReport, onSeeMoreClick };
};
